export default function authHeader(token: string, office: string) {
    if (token) {
        return {
            Authorization: 'Bearer ' + token,
            office: office
        };
    } else {
        return {
            office: {}
        };
    }
}
